import { useState, SyntheticEvent } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { Title } from 'react-admin';
import { DiscountManagerPage } from '../discount-manager';
import { BindTimesPage } from '../bind-times';
import { HailManualsPage } from '../hail-manuals';
import { CropClassesPage } from '../crop-classes';
import { HailProductDefsPage } from '../hail-product-defs';
import { IpaManagerPage } from '../ipa-manager';

const tabs = [
    { label: 'Discounts', Component: DiscountManagerPage },
    { label: 'Bind Times', Component: BindTimesPage },
    { label: 'Manuals', Component: HailManualsPage },
    { label: 'Crop Classes', Component: CropClassesPage },
    { label: 'Hail Product Defs', Component: HailProductDefsPage },
    { label: "IPA's", Component: IpaManagerPage },
];

export const HailDocsPage = () => {
    const [value, setValue] = useState(0);

    const handleChange = (_: SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const ActiveComponent = tabs[value].Component;

    return (
        <Box>
            <Title title="Hail Docs" />
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    px: 3,
                    pt: 1,
                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                >
                    {tabs.map(tab => (
                        <Tab key={tab.label} label={tab.label} />
                    ))}
                </Tabs>
            </Box>
            <ActiveComponent />
        </Box>
    );
};

export default HailDocsPage;
